module.exports = __webpack_public_path__ + "img/xinjin3.afaaf8a1.png";